var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hi-dialog',{attrs:{"title":_vm.title,"show":_vm.showDialog},on:{"close":function($event){return _vm.$emit('close')}}},[_vm._v(" dit is de dialog voor "+_vm._s(_vm.uuid)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }